import { Input } from "antd"
import { InputProps } from "antd/lib/input"
import { useEffect, useState } from "react"

type Props = InputProps & {
  onBlurChange: (value: string) => void
  highlightWhenEmpty?: boolean
}

const ChangeOnBlurInput = (props: Props) => {
  const { value, onBlur, onBlurChange, highlightWhenEmpty, ...inputProps } = props
  const [state, setState] = useState(value)

  useEffect(() => setState(value), [value])

  return <Input
    {...inputProps}
    value={state}
    onChange={e => setState(e.target.value)}
    onBlur={() => onBlurChange((state ?? '').toString())}
    status={highlightWhenEmpty && !state ? 'error' : undefined}
  />
}

export default ChangeOnBlurInput